import axios, {
  AxiosError,
  Method,
} from 'axios'

import { API_URL } from '../../../constants'

export const getHTTPTokenHeaders = (token: string): {
  Authorization: string,
} => ({
  Authorization: token ? `Bearer ${token}` : '',
})

export const setHTTPToken = (token: string) => {
  axios.defaults.headers.common = getHTTPTokenHeaders(token)
}

export const unsetHTTPToken = () => {
  axios.defaults.headers.common = getHTTPTokenHeaders('')
}

// pluck an error message from the response body if present
export const getErrorMessage = (error: AxiosError): string => {
  const res = error.response
  let message = ''
  if(res && res.data) {
    message = res.data.error || res.data.message
  }
  message = message || error.toString()
  return message.replace(/^Error\: Error\:/, 'Error:');
}

type QueryParams = Record<string, any>
type ExtraParams = QueryParams

function read(method: Method, baseUrl: string, baseParams: QueryParams = {}) {
  return async function<ResponseType>(url: string, extra: ExtraParams = {}) {
    return axios.request<ResponseType>({
      method,
      url: `${baseUrl}${url}`,
      ...extra,
      params: Object.assign({}, baseParams, extra.params),
    }).then(res => res.data)
  }
}

function write(method: Method, baseUrl: string, baseParams: QueryParams = {}) {
  return async function<RequestType, ResponseType>(url: string, data?: RequestType, extra: ExtraParams = {}) {
    return axios.request<ResponseType>({
      method,
      url: `${baseUrl}${url}`,
      data,
      ...extra,
      params: Object.assign({}, baseParams, extra.params),
    }).then(res => res.data)
  }
}

export const getHandlers = (baseUrl: string, baseParams: QueryParams = {}) => ({
  get: read('get', baseUrl, baseParams),
  post: write('post', baseUrl, baseParams),
  put: write('put', baseUrl, baseParams),
  delete: read('delete', baseUrl, baseParams),
})

export const handlers = getHandlers(API_URL)
